//Compair and Pair Scroll Button
(() => {
    // const scrollAmount = 200;

    function updateComparePairButtonVisibility(container, btnGroup, btnLeft, btnRight) {

        const isScrollable = container.scrollWidth > container.clientWidth;

        if(!isScrollable){
            btnGroup.style.display = "none";
            return
        } else {
            btnGroup.style.display = "flex";
        }

        const currentScroll = container.scrollLeft;
        const maxScroll = container.scrollWidth - container.clientWidth;

        btnLeft.style.opacity = currentScroll > 5 ? '1' : '0.5';
        btnLeft.style.pointerEvents = currentScroll > 5 ? 'auto' : 'none';

        btnRight.style.opacity = currentScroll < maxScroll - 5 ? '1' : '0.5';
        btnRight.style.pointerEvents = currentScroll < maxScroll - 5 ? 'auto' : 'none';
    }

    function comparePairButtons(root = document){
        const container = root.querySelector('.compare-pair_table-wrap');
        const btnGroup = root.querySelector('.compare-pair_button-group');
        const btnLeft = root.getElementById('compare-pair_scroll-left');
        const btnRight = root.getElementById('compare-pair_scroll-right');

        if(!container || !btnGroup || !btnLeft || !btnRight) return;

        // to get "td" width
        const getScrollStep = () => {
            const firstCell = container.querySelector('td');
            return firstCell ? firstCell.offsetWidth : 200;
        };

        btnLeft.replaceWith(btnLeft.cloneNode(true));
        btnRight.replaceWith(btnRight.cloneNode(true));

        const newBtnLeft = root.getElementById('compare-pair_scroll-left');
        const newBtnRight = root.getElementById('compare-pair_scroll-right');

        newBtnLeft.addEventListener('click', () => {
            const currentScroll = container.scrollLeft;
            const step = getScrollStep();
            const isMobile = window.innerWidth <= 676;
            
            if (isMobile && currentScroll < 100) {
                container.scrollTo({ left: 0, behavior: 'smooth' });
            } else {
                container.scrollBy({ left: -step, behavior: 'smooth' });
            }
        });

        newBtnRight.addEventListener('click', () => {
            const currentScroll = container.scrollLeft;
            const step = getScrollStep();
            const isMobile = window.innerWidth <= 676;

            if (isMobile && currentScroll < 5) {
                container.scrollTo({ left: 90, behavior: 'smooth' });
            } else {
                container.scrollBy({ left: step, behavior: 'smooth' });
            }
        });

        container.addEventListener('scroll', () => {
            updateComparePairButtonVisibility(container, btnGroup, newBtnLeft, newBtnRight)
        });

        window.addEventListener('resize', () => {
            updateComparePairButtonVisibility(container, btnGroup, newBtnLeft, newBtnRight)
        });

        updateComparePairButtonVisibility(container, btnGroup, newBtnLeft, newBtnRight);
    }

    document.addEventListener("DOMContentLoaded", () => {
        comparePairButtons(document);
    });

    document.addEventListener("shopify:section:load", (e) => {
        comparePairButtons(e.target);
    });

    document.addEventListener("shopify:section:select", (e) => {
        comparePairButtons(e.target);
    });

    document.addEventListener("shopify:section:reorder", () => {
        comparePairButtons(document);
    });
})();


// Good To Know Expand Button
document.addEventListener("DOMContentLoaded", function () {
  let tabTrigger = '.tab-expend-btn'
  
  let tabClasses = {
    hide: 'hide',
    open: 'tab-is-open',
    autoHeight: 'tab--auto-height'
  }

  document.querySelectorAll(tabTrigger).forEach(function (btn){
    btn.addEventListener('click',function(evt){
      
      let el = evt.currentTarget
      let isOpen = el.classList.contains(tabClasses.open)
      let moduleId = el.getAttribute('aria-controls')
      let container = document.getElementById(moduleId)

      let fullHeight = container.scrollHeight + 'px';
    
      if (!moduleId) {
        moduleId = el.dataset.controls
      }
    
      if (!moduleId) {
        return
      }

      if (isOpen) {
        el.classList.remove(tabClasses.open),
        container.classList.remove(tabClasses.open),
        container.style.height = '650px',
        btn.style.setProperty('--before-content', '"View More"');

        setTimeout(() => {
          const offset = 70;
          const elementPosition = btn.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - window.innerHeight + btn.offsetHeight + offset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }, 10);

      } else {
        el.classList.add(tabClasses.open),
        container.classList.add(tabClasses.open),
        container.style.height = fullHeight,
        btn.style.setProperty('--before-content', '"View Less"');
      }
      
    });
  });


  const openButtons = document.querySelectorAll('.js-drawer-open');
  const closeButtons = document.querySelectorAll('.js-drawer-close');

  openButtons.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const targetId = this.getAttribute('data-target');
      const targetDrawer = document.getElementById(targetId);

      if (targetDrawer) {
        targetDrawer.classList.add('active');
        document.body.classList.add('drawer-open');
      }
    });
  });

  const closeAll = () => {
    document.querySelectorAll('.pdp_des_drawer.active').forEach(drawer => {
      drawer.classList.remove('active');
    });
    // overlay.classList.remove('is-visible');
    document.body.classList.remove('drawer-open');
  };

  closeButtons.forEach(btn => {
    btn.addEventListener('click', closeAll);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });
});


(() => {
  const initScrollSection = () => {
    const sectionId = 'ys-bought-together-section';
    const root = document.getElementById(sectionId);

    if (!root) return;

    const container = root.querySelector('.ys-bought-together-scrollable');
    const btnGroup = root.querySelector('.ys-product-list_button-group');
    
    const btnLeft = root.querySelector('#ys-scroll-left');
    const btnRight = root.querySelector('#ys-scroll-right');

    if (!container || !btnLeft || !btnRight) return;

    // 用于老版本 Safari 的定时器变量
    let scrollTimeout = null;

    const updateButtons = () => {
        const currentScroll = container.scrollLeft;
        const maxScroll = container.scrollWidth - container.clientWidth;
        
        const isScrollable = container.scrollWidth > container.clientWidth + 5;

        if (!isScrollable) {
            if (btnGroup) btnGroup.style.display = "none";
            return;
        }
        if (btnGroup) btnGroup.style.display = "flex";

        btnLeft.style.opacity = currentScroll > 5 ? '1' : '0.3';
        btnLeft.style.pointerEvents = currentScroll > 5 ? 'auto' : 'none';

        btnRight.style.opacity = currentScroll < maxScroll - 5 ? '1' : '0.3';
        btnRight.style.pointerEvents = currentScroll < maxScroll - 5 ? 'auto' : 'none';
    };

    // 【新增】核心精准算法：获取所有子元素相对于滚动容器的绝对精确坐标（带浮点数）
    const getSnapPositions = () => {
        const items = container.querySelectorAll('.ys-related-product-item');
        const containerRect = container.getBoundingClientRect();
        return Array.from(items).map(item => {
            return item.getBoundingClientRect().left - containerRect.left + container.scrollLeft;
        });
    };

    // 【新增】核心兼容函数：平滑滚动并完美兼容 Safari 的 Scroll Snap 冲突
    const smoothScrollTo = (targetLeft) => {
        // 1. 临时关闭 Scroll Snap，防止 Safari 的内核与 JS 动画“打架”
        container.style.scrollSnapType = 'none';
        
        // 2. 触发精准滚动
        container.scrollTo({ left: targetLeft, behavior: 'smooth' });

        // 3. 滚动结束后恢复 Scroll Snap 机制
        const handleScrollEnd = () => {
            container.style.scrollSnapType = ''; // 恢复 CSS 中的默认设置
            container.removeEventListener('scrollend', handleScrollEnd);
        };

        // 优先使用现代浏览器原生支持的 scrollend 事件
        if ('onscrollend' in window) {
            container.addEventListener('scrollend', handleScrollEnd);
        } else {
            // 针对不支持 scrollend 的老旧 Safari 版本使用 setTimeout 兜底
            if (scrollTimeout) clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(handleScrollEnd, 400); // 400ms 刚好是平滑滚动的标准时间
        }
    };

    // 左翻页按钮逻辑
    btnLeft.onclick = () => {
        const snapPositions = getSnapPositions();
        if (snapPositions.length === 0) return;

        const currentScroll = container.scrollLeft;
        const idealTarget = currentScroll - container.clientWidth;

        // 寻找最接近理想翻页位置的吸附点
        let targetScroll = snapPositions.slice().reverse().find(pos => pos <= idealTarget + 10);
        if (targetScroll === undefined) targetScroll = snapPositions[0];

        // 安全兜底：如果算出的目标没发生位移，强制往前推一个元素，防止“卡死”
        if (targetScroll >= currentScroll - 5 && snapPositions.length > 1) {
            const currentIndex = snapPositions.findIndex(pos => pos >= currentScroll - 5);
            if (currentIndex > 0) targetScroll = snapPositions[currentIndex - 1];
        }

        smoothScrollTo(targetScroll);
    };

    // 右翻页按钮逻辑
    btnRight.onclick = () => {
        const snapPositions = getSnapPositions();
        if (snapPositions.length === 0) return;

        const currentScroll = container.scrollLeft;
        const idealTarget = currentScroll + container.clientWidth;

        // 寻找最接近理想翻页位置的吸附点
        let targetScroll = snapPositions.find(pos => pos >= idealTarget - 10);
        if (targetScroll === undefined) targetScroll = snapPositions[snapPositions.length - 1];

        // 安全兜底：如果算出的目标没发生位移，强制往后推一个元素，防止“卡死”
        if (targetScroll <= currentScroll + 5 && snapPositions.length > 1) {
            const currentIndex = snapPositions.findIndex(pos => pos >= currentScroll - 5);
            if (currentIndex !== -1 && currentIndex < snapPositions.length - 1) {
                targetScroll = snapPositions[currentIndex + 1];
            }
        }

        smoothScrollTo(targetScroll);
    };

    container.removeEventListener('scroll', updateButtons);
    window.removeEventListener('resize', updateButtons);

    container.addEventListener('scroll', updateButtons);
    window.addEventListener('resize', updateButtons);

    setTimeout(updateButtons, 100);
  };

  if (document.readyState === 'complete') {
    initScrollSection();
  } else {
    window.addEventListener('load', initScrollSection);
  }

  document.addEventListener('shopify:section:load', (e) => {
    const sectionTarget = document.getElementById('ys-bought-together-section');
    if (sectionTarget && sectionTarget.closest(`#shopify-section-${e.detail.sectionId}`)) {
        initScrollSection();
    }
  });

})();